import { Box } from "@mui/material"
import { CustomeIconButton } from "../../../../../../../components/customeIconButton"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { icons } from "../../../../../../../utils/icons"
import { ModelDownloadButtons } from "../../../../../../../components/donwloadFiles/model"
import { TableActionsProps } from "./types"
import { SnackSimple } from "../../../../../../../components"

export const TableActions = ({ addActivityButton, download, showDownload, count, downloadCustome, cleanActivityButton, downloadDisabled, closeOpenSnakbar, openSnackbar }: TableActionsProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    return (
        <>
            <Box sx={styles.alignHorizontal}>
                {!showDownload && (
                    <ModelDownloadButtons
                        {...download}
                        customeLabels={{
                            csv: t('general.csvActivities'),
                            pdf: t('general.pdfActivities'),
                            word: t('general.wordActivities')
                        }}

                        extraDownload={
                            [
                                {
                                    disable: downloadDisabled['pdf-detail'],
                                    dowload: () => {downloadCustome()},
                                    label: 'general.informDetail',
                                    type: 'pdf'
                                }
                            ]
                        }
                    />
                )}

                {!!count && <CustomeIconButton icon={icons('clean')} title={t('ToolTips.clearFilters')} iconButtonProps={{ sx: styles.filter, className: 'icon-size', ...cleanActivityButton }} />}

                <CustomeIconButton icon={icons('add')} title={t('loogbook.addAcitivity')} iconButtonProps={{ sx: styles.add, className: 'icon-size', ...addActivityButton }} />
            </Box>

            <SnackSimple close={closeOpenSnakbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />
        </>
    )
}